<template>
  <div class="file-upload">
    <label :for="uid" class="cursor-pointer position-relative paperclip">
      <i class="bi-paperclip position-absolute"></i>
      <slot>{{ title }}</slot>
      <small v-if="accept" class="text-nowrap text-muted accept">({{ accept }})</small>
    </label>
    <input @change="uploadFiles"
           :multiple="multiple"
           :id="uid"
           :accept="accept"
           type="file"
           class="d-none">
    <input-errors :errors="uploadErrors"/>
    <div v-for="(file, index) in files" v-bind:key="index">
      <div>
        <div v-if="clearable" v-on:click="removeFile(index)" class="cursor-pointer float-right">
          <i class="bi-x"></i>
        </div>
        <div>
          <a :href="file.downloadLink" target="_blank">
            {{ file.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createUploadManager } from "@/utils/di";
import { Forbidden, Unauthorized, ValidationError } from "@/utils/api-client";
import InputErrors from "./InputErrors.vue";

let i = 0;

const MAX_FILE_SIZE = 7 * 1024 * 1024;
const GENERIC_UPLOAD_ERROR = "Не удалось загрузить файл. Произошла непредвиденная ошибка, попробуйте позже";

export default {
  name: "FileUpload",
  components: {
    InputErrors
  },
  props: {
    files: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "Прикрепить файл"
    },
    accept: {
      type: String,
      default: ".pdf, .jpg, .jpeg, .png, .gif, .tiff, .doc, .docx"
    }
  },
  data() {
    return {
      uploadErrors: []
    };
  },
  computed: {
    uid() {
      return 'file-upload-' + ++i;
    }
  },
  methods: {
    async uploadFiles(e) {
      this.uploadErrors = [];
      const manager = await createUploadManager();
      const selectedFiles = Array.from(e.target.files);
      e.target.value = "";
      for (const file of selectedFiles) {
        if (file.size > MAX_FILE_SIZE) {
          this.uploadErrors.push(`Файл «${file.name}» слишком большой. Максимальный размер файла — 7 МБ`);
          continue;
        }
        try {
          const data = await manager.uploadFile(file);
          if (!this.multiple) {
            this.files.splice(0, this.files.length);
          }
          this.files.push(data);
        } catch (err) {
          if (err instanceof Unauthorized || err instanceof Forbidden) {
            throw err;
          }
          this.uploadErrors.push(this.extractUploadErrorMessage(err));
        }
      }
    },
    removeFile: function (index) {
      this.clearable && this.$confirm("Вы хотите удалить файл?", () => {
        this.files.splice(index, 1);
      });
    },
    extractUploadErrorMessage(err) {
      if (err instanceof ValidationError) {
        return err.message;
      }
      return err?.response?.data?.message || GENERIC_UPLOAD_ERROR;
    }
  }
};
</script>

<style lang="scss">
.file-upload {
  .paperclip {
    padding-left: 2.5rem;

    .bi-paperclip::before {
      border: 0.125rem solid #05B768;
      border-radius: 1rem;
      height: 2rem;
      width: 2rem;
      line-height: 2rem;
      text-align: center;
      margin-left: -2.5rem;
    }

    .accept {
      display: block;
    }
  }
}
</style>
